<script>
    import FullCalendar from "./CalendarType/FullCalendar.svelte";

    export let accountId = Number(0);
    export let eventColour = "";
    export let isDoctorCalendar = false;
    export let params = {};
    export let url = "";
    export let isCalendarRoute = false;
</script>

<FullCalendar
    {accountId}
    {eventColour}
    {isDoctorCalendar}
    {params}
    {url}
    {isCalendarRoute}
/>
